import { User } from '@sentry/types';
import { Box, Grid } from 'grommet';
import Forbidden from 'modules/auth/components/Forbidden';
import { auth$ } from 'modules/auth/stream/auth$';
import CourseAdmin from 'modules/course/CourseAdmin';
import NewsAdmin from 'modules/news/NewsAdmin';
import PageAdmin from 'modules/page/PageAdmin';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import { dispatchAction } from 'rxbeach';
import { connect } from 'rxbeach/react';
import { adminSetActive } from './admin$';
import AssetNavigator from './components/AssetNavigator';
import { AssetAdminTab } from './types';

const AdminPanel = ({ user }: { user: User | null }) => {
  const [tab, setTab] = useState(AssetAdminTab.PAGES);
  const param = useParams<{ tab: string, id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const incommingTab = param.tab as AssetAdminTab;
    if (!param.id) dispatchAction(adminSetActive(null));
    if (!Object.values(AssetAdminTab).includes(incommingTab)) return;
    setTab(incommingTab)
  }, [param.tab, param.id]);


  if (!user) return <Forbidden />;

  return (
    <Box height="100%">
      <Grid
        fill
        areas={[
          { name: 'nav', start: [0, 0], end: [0, 0] },
          { name: 'main', start: [1, 0], end: [1, 0] },
        ]}
        columns={['small', 'flex']}
        rows={['85vh']}
        gap="small"
      >
        <Box gridArea="nav" background="white" border="right">
          <AssetNavigator handleClick={e => {
            setTab(e)
            dispatchAction(adminSetActive(null))
            navigate(`/admin/${e}`)
          }} activeTab={tab} />
        </Box>
        <Box gridArea="main" margin="small">
          {tab === AssetAdminTab.NEWS && <NewsAdmin />}
          {tab === AssetAdminTab.PAGES && <PageAdmin />}
          {tab === AssetAdminTab.COURSE && <CourseAdmin />}
        </Box>
      </Grid>
    </Box>
  );
};

export default connect(AdminPanel, auth$);
